export const FINANCE_CATEGORIES = [
  "accounting", "software", "insurance", "office", "marketing", "travel", "other",
];

export function formatBillingMonth(value, lang = "en") {
  if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(String(value || ""))) return value || "–";
  return new Intl.DateTimeFormat(lang === "de" ? "de-DE" : "en-GB", {
    month: "long", year: "numeric", timeZone: "UTC",
  }).format(new Date(`${value}-01T12:00:00Z`));
}

export function financeCategoryLabel(value, t) {
  return FINANCE_CATEGORIES.includes(value) ? t(`financeCategory_${value}`) : value || "–";
}

export function formatIban(value) {
  return String(value || "").replace(/\s+/g, "").replace(/(.{4})/g, "$1 ").trim();
}
